import { Flame, X } from "lucide-react";

export function WeeklyMilestoneModal({ milestone, streak, onDismiss }) {
  if (!milestone) return null;

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm animate-in fade-in duration-300">
      <div className="relative w-full max-w-sm bg-brand-surface border border-white/10 rounded-3xl overflow-hidden shadow-2xl animate-in zoom-in-95 duration-300">
        <button
          onClick={onDismiss}
          className="absolute top-4 right-4 p-2 rounded-full bg-white/5 text-gray-400 hover:text-white transition-colors z-10"
        >
          <X size={16} />
        </button>

        {/* Celebration Header */}
        <div className="relative px-6 pt-10 pb-6 bg-gradient-to-br from-amber-500/20 via-orange-500/10 to-transparent text-center">
          <div className="text-6xl mb-4 animate-bounce">{milestone.icon}</div>
          <h2 className="text-2xl font-bold text-white mb-1">
            {milestone.title}
          </h2>
          <div className="flex items-center justify-center gap-2 mt-3">
            <Flame size={16} className="text-orange-400" />
            <span className="text-sm font-bold text-orange-400">
              {streak} Day Streak
            </span>
            <Flame size={16} className="text-orange-400" />
          </div>
        </div>

        <div className="px-6 py-6 space-y-4">
          <p className="text-sm text-gray-300 text-center leading-relaxed">
            {milestone.message}
          </p>

          {/* Streak visualization */}
          <div className="flex justify-center gap-1">
            {Array.from({ length: 7 }).map((_, i) => (
              <div
                key={i}
                className="w-8 h-8 rounded-lg bg-brand-green/20 border border-brand-green/30 flex items-center justify-center"
              >
                <span className="text-brand-green text-xs font-bold">✓</span>
              </div>
            ))}
          </div>

          <button
            onClick={onDismiss}
            style={{ touchAction: "manipulation" }}
            className="w-full py-4 rounded-2xl bg-brand-green hover:bg-emerald-400 text-brand-bg font-bold text-sm uppercase tracking-widest transition-all active:scale-[0.98] shadow-[0_0_20px_rgba(16,185,129,0.3)]"
          >
            Keep Going!
          </button>
        </div>
      </div>
    </div>
  );
}
